import { ViewportContext } from '@/context/ViewportContext';
import { Viewport } from '@xyflow/react';
import { useEffect, useState } from 'react';

export const ViewportProvider = ({ children }: { children: React.ReactNode }) => {
  const [viewports, setViewports] = useState<Record<string, Viewport>>({});
  const [centerOnNode, setCenterOnNode] = useState<string>();

  const handleViewportsChange = (viewports?: Record<string, Viewport>) => {
    localStorage.setItem('viewports', viewports ? JSON.stringify(viewports) : '{}');
    setViewports(viewports || {});
  };

  useEffect(() => {
    const savedViewPorts = localStorage.getItem('viewports');
    if (!savedViewPorts) return;

    const parsedViewPort = JSON.parse(savedViewPorts);
    parsedViewPort && setViewports(parsedViewPort);
  }, []);

  return (
    <ViewportContext.Provider
      value={{
        viewports: viewports,
        setViewports: handleViewportsChange,
        centerOnNode: centerOnNode,
        setCenterOnNode: setCenterOnNode
      }}
    >
      {children}
    </ViewportContext.Provider>
  );
};
